@if (showModal()) {
  <div class="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[1500] p-4">
    <div
        class="bg-dark-gray rounded-2xl border border-white/10 shadow-glow max-w-md w-full animate-appear overflow-hidden">
      <div class="p-6 flex flex-col items-center">
        <div class="text-electric-blue mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
        </div>
        <h2 class="text-2xl font-bold text-white mb-3">No Matches Found</h2>
        <p class="text-white/70 text-center mb-6">
          {{ modalData()?.message || 'We could not find good matches for your query. Please try with different visuals or add more descriptive text.' }}
        </p>
        <div class="flex justify-center">
          <button (click)="closeModal()"
                  class="btn btn-primary py-2 px-6 text-white bg-gradient-to-r from-electric-blue to-electric-blue/80 hover:shadow-glow-sm hover:-translate-y-0.5 transition-all rounded-lg">
            Try Again
          </button>
        </div>
      </div>
    </div>
  </div>
}
